import {isNil} from 'ramda';

import {ScopeValues} from '@dms/api/shared';

export const evaluateBranch = (
  scopes: string[],
  evaluatorParams: ScopeValues | undefined,
  userBranchesIds: string[]
) => {
  if (
    isNil(evaluatorParams) ||
    (!('branchId' in evaluatorParams) && !('branchIds' in evaluatorParams))
  ) {
    return false;
  }
  if (evaluatorParams.branchId === 'SKIP') {
    return true;
  }

  // scopes is array at maximal size of 2, so this check is fine
  if (scopes.includes('ALL_BRANCHES')) {
    return true;
  }
  if (scopes.includes('MY_BRANCHES')) {
    if (evaluatorParams.branchId) {
      return userBranchesIds.includes(evaluatorParams.branchId);
    }

    if ('branchIds' in evaluatorParams) {
      return Boolean(
        evaluatorParams.branchIds?.some((branchId) => userBranchesIds.includes(branchId))
      );
    }
  }

  return false;
};
